import { CampaignTypeEnum } from "src/_api";

export const CampaignTypeTranslations = {
  [CampaignTypeEnum.Standard]: 'Standard',
  [CampaignTypeEnum.Impact]: 'Impact',
  [CampaignTypeEnum.Plugg]: 'Plugg'
};
